import { gql } from '@apollo/client';
import { StaffingSettings } from './staffing-settings.fragment';
export const FetchStaffingSettings = gql `
    query FetchStaffingSettings($siteSetId: InstitutionSetId!) {
        staffhours {
            settings(siteSetId: $siteSetId) {
                ...StaffingSettings
            }
        }
    }
    ${StaffingSettings}
`;
